import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const CourseDeviceIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='devices' clipPath='url(#clip0_5161_54792)'>
      <path
        id='Vector'
        d='M4 6H22V4H4C2.9 4 2 4.9 2 6V17H0V20H14V17H4V6ZM23 8H17C16.45 8 16 8.45 16 9V19C16 19.55 16.45 20 17 20H23C23.55 20 24 19.55 24 19V9C24 8.45 23.55 8 23 8ZM22 17H18V10H22V17Z'
        fill='white'
      />
    </g>
    <defs>
      <clipPath id='clip0_5161_54792'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default CourseDeviceIcon;
